import React, { useState, useEffect } from "react";
import axios from "axios";
import AlertComponent from "_metronic/_helpers/AlertComponent";
import RenderIf from "app/components/RenderIf";
import Loading from "app/components/Loading";
import Table from "./components/Table";
import { Button } from "react-bootstrap";
import { objectToQueryString } from "../../../_metronic/_helpers";
import { DateTimePicker } from "../../components/DatePicker";
import dayjs from "dayjs";
import Input from "app/components/Input";
import useDebounce from "app/hooks/useDebounce";
const date = new Date();

const initialStartDate =
  new Date(date.getFullYear(), date.getMonth(), date.getDate())
    .toISOString()
    .split("T")[0] + "T00:00";

export default function WorkerWeeklyReport() {
  const [state, setState] = useState({
    isLoading: false,
    error: null,
    data: null,
  });
  const [filters, setFilters] = useState({
    agentNumber: "",
    date: initialStartDate,
    skip: 0,
    take: 10,
    sortField: "",
    orderBy: false,
  });

  const debouncedFilters = useDebounce(filters, 500);

  async function getData() {
    const query = objectToQueryString({
      ...debouncedFilters,
    });

    setState((prevState) => ({
      ...prevState,
      isLoading: true,
    }));
    try {
      const { data } = await axios({
        method: "GET",
        url: `worker/weeklyReport?${query}`,
      });

      setState({
        isLoading: false,
        error: null,
        data,
      });
    } catch (err) {
      setState({
        isLoading: false,
        error: err?.response?.data,
        data: null,
      });
    }
  }

  async function getExcel() {
    const { skip, take, ...rest } = filters;
    const query = objectToQueryString({
      ...rest,
    });

    try {
      const { data } = await axios({
        url: `worker?${query}`,
        method: "GET",
        headers: {
          "X-Content-Type": "application/xlsx",
        },
        responseType: "blob",
      });
      const blob = new Blob([data], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Worker.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (err) {}
  }

  function handleChangeDate(e) {
    setFilters({
      ...filters,
      date: e.replace(" ", "T").slice(0, e.length - 3),
    });
  }

  useEffect(() => {
    getData();
  }, [debouncedFilters]);

  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center pb-4">
        <h2 className="mb-0 font-weight-bolder">Worker həftəlik hesabatı</h2>

        <RenderIf condition={state?.data?.length}>
          <Button
            onClick={getExcel}
            variant="outline-success"
            className="ml-auto"
          >
            Download excel
          </Button>
        </RenderIf>
      </div>
      <div className="col-12 py-4 overflow-auto">
        <div className="d-flex w-100">
          <DateTimePicker
            showTime
            value={filters.date ? dayjs(filters.date) : ""}
            onChange={handleChangeDate}
            className="mr-2"
          />
          <Input
            name="agentNumber"
            value={filters.agentNumber}
            onChange={(e) =>
              setFilters({ ...filters, agentNumber: e.target.value })
            }
            placeholder="Agent number"
            className="form-control form-control-solid py-1 px-6 mr-2"
            style={{ width: "200px" }}
          />
        </div>
        <RenderIf condition={state.data?.data?.length}>
          <Table
            data={state.data}
            isLoading={state.isLoading}
            filters={filters}
            setFilters={setFilters}
          />
        </RenderIf>
        <RenderIf condition={state.isLoading}>
          <div className="d-flex justify-content-center">
            <Loading />
          </div>
        </RenderIf>
        <RenderIf
          condition={!state.isLoading && state.data?.reportList?.length === 0}
        >
          <AlertComponent message="Məlumat tapılmadı" variant="info" />
        </RenderIf>
        <RenderIf condition={!state.isLoading && state.error}>
          <AlertComponent message="Xəta baş verdi" variant="danger" />
        </RenderIf>
      </div>
    </div>
  );
}
